export default __webpack_public_path__ + "static/world-map-ff17447f1686abf469300605d135af0e.png";